import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const TimeIcon = () => (
    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" aria-hidden="true">
        <path fill="currentColor" d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88a88.1 88.1 0 0 1-88 88m64-88a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V72a8 8 0 0 1 16 0v48h48a8 8 0 0 1 8 8" />
    </svg>
)

const WhatsAppIcon = () => (
    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28" />
    </svg>
)

const ArrowIcon = () => (
    <svg className="-mx-[5px] h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" aria-hidden="true">
        <path fill="currentColor" d="m184.49 136.49l-80 80a12 12 0 0 1-17-17L159 128L87.51 56.49a12 12 0 1 1 17-17l80 80a12 12 0 0 1-.02 17" />
    </svg>
)

const MediaCard = ({
    imageSrc,
    alt,
    title,
    duration,
    whatsappLink,
    link,
    onClick
}) => {
    return (
        <div className="group relative flex items-center gap-4 bg-white p-4 shadow dark:bg-gray-800 sm:rounded-md">
            <div className="w-24 md:w-36">
                {imageSrc && imageSrc.images ?
                    <div className="relative rounded-md bg-black">
                        <GatsbyImage
                            image={imageSrc}
                            alt={alt}
                            className="absolute left-0 top-0 h-full w-full rounded-md object-contain group-hover:opacity-80"
                            imgClassName="rounded-md"
                            loading="lazy"
                        />
                    </div> :
                    <div className="relative rounded-md bg-black pb-[75%]">
                        <img
                            src={imageSrc}
                            alt={alt}
                            className="absolute left-0 top-0 h-full w-full rounded-md object-contain group-hover:opacity-80"
                        />
                    </div>
                }
            </div>
            <div className="flex-1 md:p-2">
                <h2 className="mb-1 md:mb-3">
                    {link ? (
                        <Link
                            to={link}
                            className="line-clamp-2 cursor-pointer before:absolute before:left-0 before:top-0 before:h-full before:w-full before:content-[''] hover:text-sky-400 md:text-xl"
                        >
                            {title}
                        </Link>
                    ) : (
                        <li
                            onClick={onClick}
                            className="line-clamp-2 cursor-pointer before:absolute before:left-0 before:top-0 before:h-full before:w-full before:content-[''] hover:text-sky-400 md:text-xl"
                        >
                            {title}
                        </li>
                    )}
                </h2>

                <div className="flex items-center gap-2">
                    <TimeIcon />
                    <span>{duration}</span>
                    <span className="mx-2 text-gray-400">|</span>
                    <Link
                        className="relative inline-flex hover:text-sky-400"
                        to={whatsappLink}
                        aria-label={`Share ${title} on WhatsApp`}
                    >
                        <WhatsAppIcon />
                    </Link>
                </div>
            </div>

            <ArrowIcon />
        </div>
    )
}

export default MediaCard